<template>
  <div
    class="ml-6 uppercase font-bold text-xs pt-5 -mb-3"
    :class="{ 'text-blue-500': color === 'blue', 'text-gray-500': !color || color === 'gray' }"
  >
    <i v-if="icon" class="mr-2" :class="icon"></i><span>{{ title }}</span>
    <slot name="actions"></slot>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  icon?: string;
  title: string;
  color?: 'gray' | 'blue';
}>();
</script>

<style scoped></style>
